const services = [
  {
    icon: "ri-live-line",
    title: "各平台直播",
    desc: "17LIVE、浪LIVE 等主流平台直播合作，專業主播資源，流量扶持，品牌曝光最大化。",
    tags: ["17LIVE", "浪LIVE", "品牌直播"],
    color: "bg-red-50 border-red-100",
    iconColor: "text-red-600 bg-red-100",
  },
  {
    icon: "ri-store-2-line",
    title: "展場活動",
    desc: "大型展覽、市集、品牌快閃活動規劃執行，從場地佈置到現場管理一手包辦。",
    tags: ["展覽規劃", "品牌快閃", "市集活動"],
    color: "bg-orange-50 border-orange-100",
    iconColor: "text-orange-600 bg-orange-100",
  },
  {
    icon: "ri-user-star-line",
    title: "SG / 展場人員",
    desc: "專業形象佳、表達能力強的 SG 人員，適合各類展場、發表會、品牌活動現場服務。",
    tags: ["SG 人員", "展場服務", "品牌形象"],
    color: "bg-pink-50 border-pink-100",
    iconColor: "text-pink-600 bg-pink-100",
  },
  {
    icon: "ri-music-2-line",
    title: "舞團表演",
    desc: "專業舞蹈表演團隊，適合開幕典禮、晚會、品牌發表、婚禮等各類場合演出。",
    tags: ["舞蹈表演", "開幕典禮", "晚會演出"],
    color: "bg-purple-50 border-purple-100",
    iconColor: "text-purple-600 bg-purple-100",
  },
  {
    icon: "ri-calendar-event-line",
    title: "活動策劃",
    desc: "從概念發想到執行落地，提供完整活動策劃服務，讓每場活動都成為難忘的體驗。",
    tags: ["活動企劃", "主題設計", "全程執行"],
    color: "bg-amber-50 border-amber-100",
    iconColor: "text-amber-600 bg-amber-100",
  },
  {
    icon: "ri-megaphone-line",
    title: "網紅業配代言",
    desc: "媒合品牌與網紅 KOL，精準觸及目標受眾，提升品牌知名度與銷售轉換率。",
    tags: ["KOL 合作", "業配推廣", "品牌代言"],
    color: "bg-green-50 border-green-100",
    iconColor: "text-green-600 bg-green-100",
  },
  {
    icon: "ri-image-line",
    title: "網紅形象廣告",
    desc: "專業形象廣告拍攝製作，打造網紅個人品牌形象，提升社群影響力與商業價值。",
    tags: ["形象廣告", "個人品牌", "社群行銷"],
    color: "bg-sky-50 border-sky-100",
    iconColor: "text-sky-600 bg-sky-100",
  },
  {
    icon: "ri-team-line",
    title: "網紅策劃聯盟",
    desc: "整合多位網紅資源，策劃聯合行銷活動，擴大品牌聲量，創造話題效應。",
    tags: ["聯合行銷", "話題策劃", "多 KOL 合作"],
    color: "bg-teal-50 border-teal-100",
    iconColor: "text-teal-600 bg-teal-100",
  },
  {
    icon: "ri-shake-hands-line",
    title: "異業合作",
    desc: "跨產業資源整合，尋找互補品牌共同合作，創造雙贏局面，拓展市場版圖。",
    tags: ["跨界合作", "資源整合", "品牌聯名"],
    color: "bg-indigo-50 border-indigo-100",
    iconColor: "text-indigo-600 bg-indigo-100",
  },
  {
    icon: "ri-camera-3-line",
    title: "拍照攝影紀錄",
    desc: "專業攝影師團隊，活動現場紀錄、商業攝影、形象照拍攝，留下每個精彩瞬間。",
    tags: ["活動攝影", "商業攝影", "形象拍攝"],
    color: "bg-rose-50 border-rose-100",
    iconColor: "text-rose-600 bg-rose-100",
  },
];

export default function BusinessServices() {
  return (
    <section id="biz-services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-widest uppercase mb-4">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            多元業務項目
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            私訊 IG 或其他訊息洽談，我們提供全方位的娛樂與行銷解決方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {services.map((s) => (
            <div
              key={s.title}
              className={`rounded-2xl border p-6 ${s.color} hover:-translate-y-1 transition-transform duration-200 cursor-default`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.iconColor} mb-4`}>
                <i className={`${s.icon} text-xl`} />
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{s.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {s.tags.map((tag) => (
                  <span key={tag} className="px-2.5 py-0.5 rounded-full bg-white/70 text-gray-600 text-xs font-medium border border-gray-200">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-14 rounded-3xl bg-gradient-to-r from-red-600 to-red-800 p-10 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-black mb-3" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            有合作想法？私訊我們！
          </h3>
          <p className="text-white/80 text-sm mb-6 max-w-lg mx-auto">
            私訊 IG 或填寫下方表單，我們會在 24 小時內回覆你的合作提案
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://www.instagram.com/rappy.meme/"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-white text-red-700 font-semibold text-sm hover:bg-red-50 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-instagram-line text-base" />
              私訊 Instagram
            </a>
            <a
              href="#biz-form"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full border-2 border-white text-white font-semibold text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base" />
              填寫合作表單
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
